module.exports = __webpack_public_path__ + "static/FlutterNewsApp-69bdf6cdecacb5ff35133ecee5e200c4.png";